import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "bg-black-body m-3" }
const _hoisted_2 = { class: "flex text-white justify-center items-center p-3 lg:p-10" }
const _hoisted_3 = { class: "w-full md:w-100 bg-black-primary" }
const _hoisted_4 = { class: "mb-5 lg:mb-10 grid grid-cols-2" }
const _hoisted_5 = {
  key: 0,
  class: "px-4 pb-5 lg:px-10"
}
const _hoisted_6 = {
  key: 1,
  class: "px-4 pb-5 lg:px-10"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_notificationsDisplayUnreadComponent = _resolveComponent("notificationsDisplayUnreadComponent")!
  const _component_notificationsDisplayAllComponent = _resolveComponent("notificationsDisplayAllComponent")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: _normalizeClass(["text-white text-center font-semibold text-xs sm:text-sm p-5 lg:p-7", { 'bg-black-body cursor-pointer hover:bg-black-sidebar transition-all duration-200':(_ctx.selectedComponent == 'all') }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectedComponent = 'unread'))
          }, "Action Required", 2),
          _createElementVNode("div", {
            class: _normalizeClass(["text-white text-center font-semibold text-xs sm:text-sm p-5 lg:p-7", { 'bg-black-body cursor-pointer hover:bg-black-sidebar transition-all duration-200':(_ctx.selectedComponent == 'unread') }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedComponent = 'all'))
          }, "All notification", 2)
        ]),
        (_ctx.selectedComponent == 'unread')
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_notificationsDisplayUnreadComponent)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_notificationsDisplayAllComponent)
            ]))
      ])
    ])
  ]))
}